<template>
  <div>
    <Loading v-if="this.$store.state.LOADING"></Loading>
    <div>
      <div v-if="swiperList.length>0" class="close" @click="close">x</div>
      <swiper :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <swiper-slide class="swiper-img" v-for="(itm,idx) in swiperList" :key="idx">
          <template v-if="itm.type === 2">
            <video controls="controls" class="ui image center" :poster="itm.pic" :src="itm.video" style="width:100%;"></video>
          </template>
          <template v-else>
            <img class="ui image center" :src="itm.pic" style="width:100%;">
          </template>
        </swiper-slide>
        <!-- Optional controls -->
        <div class="swiper-pagination"  slot="pagination">

        </div>
        <div class="swiper-button-prev" slot="button-prev" @click="goto(-1)"></div>
        <div class="swiper-button-next" slot="button-next" @click="goto(1)"></div>
        <!--    <div class="swiper-scrollbar"   slot="scrollbar"></div>-->
      </swiper>
    </div>
  </div>
</template>

<script>
  // 引入插件
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import 'swiper/swiper-bundle.min.css'
  import Loading from './loading';
  export default {
    name: 'MySwiper',
    components: {
      Loading,
      swiper,
      swiperSlide
    },
    data() {
      return {
        activeSlide:0,
        hasMore:1,
        curPage:1,
        appendNumbers:0,
        swiperOption: {
          // some swiper options/callbacks
          // 所有的参数同 swiper 官方 api 参数
          // ...
        },
        swiperList:[

        ]
      };
    },
    computed: {
      swiper(){
        return this.$refs.mySwiper.swiper
      }
    },
    mounted() {
      let self = this
      self.getDataByChooseDay(this.$store.state.chooseDay)
      // this.swiper.slideTo(0, 1000, false)
    },
    methods:{
      close(){
        this.$store.commit('hideSwiper')
      },
      goto(idx){
        let index = this.swiper.activeIndex + idx
        if (index<0){
          index=0
        }
        if (index >= this.swiperList.length-1){
          index = this.swiperList.length - 1
        }
        this.swiper.slideTo(index, 1000, false)
        this.activeSlide = index
      },
      getChooseDayYnM(chooseDay){
        let date = new Date(chooseDay)
        let res = date.getFullYear()+''+(date.getMonth()+1)
        return res
      },
      getDataByChooseDay(chooseDay){
        let self = this
        let url = self.serverUrl + 'health-calendar/month?chooseDay='+ encodeURIComponent(chooseDay)
        self.$store.commit('showLoading')
        self.$store.commit('hasData')
        this.axios.get(url)
          .then(function (response) {
            self.$store.commit('hideLoading')
            let data = response.data
            if (data.code === 200){
              let data2 = data.data
              for (let i in data2){
                var html = {'type':data2[i].type, 'pic':data2[i].pic_path, 'video':data2[i].video_path, 'url':data2[i].link, 'day':data2[i].day}
                self.swiperList.push(html)
              }
              self.swiperList.reverse()
              let curDay = self.$store.state.chooseDay

              let slideto = -1
              for (let i=0; i<self.swiperList.length; i++){
                if (self.swiperList[i].day === curDay){
                  slideto = i
                  break;
                }
              }
              if (slideto>=0){
                self.swiper.slideTo(slideto, 1000, false)
              } else {
                self.$store.commit('hideSwiper')
              }
            } else {
              self.$store.commit('hideSwiper')
            }
          })
          .catch(function (error) {
            console.log(error);
            self.$store.commit('hideLoading')
          });
      }
    }
  }
</script>
<style lang='less' scoped>
  .swiper-container{
    .swiper-wrapper{
      .swiper-slide{
        img{
          width:100%;
        }
      }
    }
    /*height:200px;*/
    .swiper-button-prev{
      position: absolute;
      top: 50%;
      width: calc(var(--swiper-navigation-size)/ 44 * 27);
      height: var(--swiper-navigation-size);
      margin-top: calc(-1 * var(--swiper-navigation-size)/ 2);
      z-index: 10;
      cursor: pointer;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      color:#72b086;
      left: 5px;
      right: auto;
    }
    .swiper-button-prev::after{
      font-family: swiper-icons;
      font-size: var(--swiper-navigation-size);
      text-transform: none!important;
      letter-spacing: 0;
      text-transform: none;
      font-variant: initial;
      line-height: 1;
    }
    .swiper-button-next{
      position: absolute;
      top: 50%;
      width: calc(var(--swiper-navigation-size)/ 44 * 27);
      height: var(--swiper-navigation-size);
      margin-top: calc(-1 * var(--swiper-navigation-size)/ 2);
      z-index: 10;
      cursor: pointer;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      color:#72b086;
      right:5px;
      left: auto;
    }
    .swiper-button-next::after{
      font-family: swiper-icons;
      font-size: var(--swiper-navigation-size);
      text-transform: none!important;
      letter-spacing: 0;
      text-transform: none;
      font-variant: initial;
      line-height: 1;
    }
  }
  .close{
    font-size: 2rem;
    height: 2rem;
    line-height: 2rem;
    width: 2rem;
    margin: 0 auto;
    background: white;
    border: 1px solid #d61818;
    border-radius: 3rem;
    color: #d61818;
    z-index: 2;
    top: 0;
    right: 0px;
    left: auto;
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/components/MySwiper.vue